import { RicosViewer, useRicosTheme } from '@wix/form-fields';
import React from 'react';
import styles from './disabled-form-overlay.module.scss';
const paragraphCustomStylesWUT = {
    p: {
        fontSize: 'var(--wix-forms-formParagraphFont-size)',
        fontFamily: 'var(--wix-forms-formParagraphFont-family)',
        color: 'rgb(var(---wix-forms-formParagraphColor))',
    },
};
const RICOS_THEME = { customStyles: paragraphCustomStylesWUT };
export const DisabledFormOverlay = ({ content, isEditor, }) => {
    const customTheme = useRicosTheme(RICOS_THEME);
    if (isEditor || !content) {
        return null;
    }
    return (React.createElement(RicosViewer, { content: content, className: styles.disabledFormOverlay, customTheme: customTheme }));
};
//# sourceMappingURL=disabled-form-overlay.js.map